import { CHARTING_TABLE_OBJECT } from "../../config/constants/Constants";
import { DEFAULT_SUMMARY_DATA } from "./teethDataNormalize";

export const PRACTICE_PATIENT = {
    id: "practice",
    patient_identifier: "PRACTICE",
    first_name: "Practice",
    last_name: "Patient",
    birth_date: null,
    notes: null
};

export const patientOwnerKey = (patient) => {
    if (patient?.id == null || patient.id === PRACTICE_PATIENT.id) return null;
    return `patient:${patient.id}`;
};

export const blankChart = () => JSON.parse(JSON.stringify(CHARTING_TABLE_OBJECT));

export const blankSummary = () => JSON.parse(JSON.stringify(DEFAULT_SUMMARY_DATA));

export const createFreshDraft = (scope, ownerKey, patient = null) => ({
    scope,
    ownerKey,
    patient,
    chartPlaqueSeparately: true,
    chartingTable: blankChart(),
    summaryData: blankSummary()
});

export const createPracticeDraft = () => createFreshDraft("practice", "practice", { ...PRACTICE_PATIENT });

export const chartHasEntries = (chart) => {
    if (!chart) return false;
    return JSON.stringify(chart) !== JSON.stringify(blankChart());
};

const bindEditDraft = (draft, patient) => ({
    ...draft,
    patient: patient ?? draft.patient
});

const bindNewExaminationDraft = (draft, patient) => {
    const nextKey = patientOwnerKey(patient);
    const currentKey = draft.ownerKey || patientOwnerKey(draft.patient);

    if (nextKey != null && currentKey === nextKey) {
        return { ...draft, scope: "new", ownerKey: nextKey, patient };
    }

    if (nextKey == null) {
        return { ...draft, scope: "new", ownerKey: null, patient: patient ?? null };
    }

    return {
        ...createFreshDraft("new", nextKey, patient),
        chartPlaqueSeparately: draft.chartPlaqueSeparately
    };
};

export const bindDraftPatient = (draft, patient) => {
    if (!draft || draft.scope === "practice") return draft;
    if (draft.scope === "edit") return bindEditDraft(draft, patient);
    return bindNewExaminationDraft(draft, patient);
};
